import type { FC } from "react";
import type { PersonCardProps } from "../../PersonCard";
import { PersonCard } from "../../PersonCard";

export const PersonBlockMobile: FC<
  Pick<PersonCardProps, "showMobileMenu" | "isEdit" | "showEdit" | "form">
> = ({ showMobileMenu, isEdit, showEdit, form }) => {
  return (
    <PersonCard showMobileMenu={showMobileMenu} isEdit={isEdit} showEdit={showEdit} form={form} />
  );
};
